// Global error handler to prevent any toast during logout
import { toast } from 'react-toastify';

let isBlockingToasts = false;

// Store original console methods
const originalConsole = {
  error: console.error,
  warn: console.warn,
  log: console.log
};

export const setGlobalToastBlocking = (block: boolean) => {
  isBlockingToasts = block;
  
  if (block) {
    // Override console methods that might trigger toasts
    console.error = (...args) => {
      // Check if any argument contains session-related errors
      const message = args.join(' ').toLowerCase();
      if (message.includes('token') || message.includes('session') || message.includes('unauthorized')) {
        originalConsole.log('Session error blocked during logout:', ...args);
        return;
      }
      originalConsole.error(...args);
    };
    
    console.warn = (...args) => {
      const message = args.join(' ').toLowerCase();
      if (message.includes('token') || message.includes('session') || message.includes('unauthorized')) {
        originalConsole.log('Session warning blocked during logout:', ...args);
        return;
      }
      originalConsole.warn(...args);
    };
    
    // Monkey patch any potential toast libraries
    if ((window as any).Toastify) {
      (window as any).Toastify.error = () => { };
      (window as any).Toastify.success = () => { };
    }
    
    if ((window as any).toastr) {
      (window as any).toastr.error = () => { };
      (window as any).toastr.success = () => { };
      (window as any).toastr.warning = () => { };
      (window as any).toastr.info = () => { };
    }
    
  } else {
    // Restore original console methods
    console.error = originalConsole.error;
    console.warn = originalConsole.warn;
    console.log = originalConsole.log;
  }
};